import {
  Box,
  AHSeparator,
  ListItem,
  AHIcon,
  AHTextFonts,
  AHText,
  SubTodoIndicator,
} from "arkh";
import React, { useState } from "react";

import { useFragment, graphql } from "react-relay";
import { TodoEditNewMainSubTodos_todo$key } from "./__generated__/TodoEditNewMainSubTodos_todo.graphql";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";

import { TodoEditNewMainPreventDefault } from "./TodoEditNewMainPreventDefault";
import { TodoListItemSubTodo } from "./TodoListItemSubTodo";

export const TodoEditNewMainSubTodos = React.memo(TodoEditNewMainSubTodosC);
function TodoEditNewMainSubTodosC(props: {
  todo: TodoEditNewMainSubTodos_todo$key;
  onOpenTodo: (fromResponse: boolean, todoId: string) => void;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoEditNewMainSubTodos_todo on Todo {
        subTodos {
          id
          ...TodoListItemSubTodo_todo
          status
        }
        ...TodoEditNewMainPreventDefault_todo
      }
    `,
    props.todo
  );
  const todoLength = todo?.subTodos?.length ?? 0;
  const intl_tokens = useIntlTokens();
  const [isOpen, setIsOpen] = useState(true);
  const subTodoStatuses =
    todo?.subTodos?.map((subTodo) => subTodo.status) ?? [];
  if (todoLength === 0) {
    return null;
  }
  return (
    <>
      <TodoEditNewMainPreventDefault todo={todo} />
      <Box spaceTop="medium" spaceHorizontal="medium">
        <ListItem
          border="border-primary"
          isFirst
          isLast={!isOpen}
          onPress={() => setIsOpen((p) => !p)}
          right={
            <Box style={{ flexDirection: "row", alignItems: "center" }}>
              <SubTodoIndicator statuses={subTodoStatuses} />
              <AHIcon
                spaceLeft="small"
                type={isOpen ? "chevron-up" : "chevron-down"}
                size="small"
                color="text-secondary"
              />
            </Box>
          }
        >
          <AHText
            selectable={false}
            size={11}
            font={AHTextFonts.BOLD}
            color="text-secondary"
          >
            {intl_tokens.SubTodos}
          </AHText>
        </ListItem>
        {isOpen ? (
          <Box
            insets={{
              left: 1,
              right: 1,
              bottom: 1,
            }}
          >
            {(todo?.subTodos?.length ?? 0) > 0 ? (
              <>
                {todo?.subTodos?.map((item, i, arr) => (
                  <React.Fragment key={item.id}>
                    <AHSeparator />
                    <TodoListItemSubTodo
                      todo={item}
                      isLast={i === arr.length - 1}
                      openTodo={props.onOpenTodo}
                    />
                  </React.Fragment>
                ))}
              </>
            ) : null}
          </Box>
        ) : null}
      </Box>
    </>
  );
}
